function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgSecurityScreenIcon = function SvgSecurityScreenIcon(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 40,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M18 37H5a4 4 0 0 1-4-4V21a4 4 0 0 1 4-4h20a4 4 0 0 1 3.48 2.024M7 17V9a8 8 0 1 1 16 0v8"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: props.accentFillLine,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m29 27-4 6h8l-4 6M13 27a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z"
  }));
};
export default SvgSecurityScreenIcon;